import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common-services/common.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import * as EmailValidator from 'email-validator';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit{
  baseUrl = environment.BASE_URL;
  subcriptionForm!: FormGroup;

  constructor(
    private service: CommonService,
    private fb : FormBuilder,
    private toastr: ToastrService
  ){  }
  
  ngOnInit() {
    this.subcriptionForm = this.fb.group({
      email: ['', Validators.required],
    });
  }

  get validateEmail(){
    return EmailValidator.validate(this.subcriptionForm.value.email); 
  }

  isValid() {
    if (this.subcriptionForm.controls['email'].status === 'INVALID') {
      return true;
    } else {
      return false;
    }
  }

  subcriptionSubmit(){
    this.service.postDatawithoutHeaders(`${this.baseUrl}customer/subscription-management`, { email: this.subcriptionForm.value.email, subscriptionType: 'NEWS_LETTER' }).subscribe({
        next: (res:any) => {
          this.toastr.success('Subscribe Email Successfully!');
          this.subcriptionForm.reset();
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error(error.error.status.error.message);
        }
    })
  }

}
